import {
	GET_VIEWER_ALL_DOCUMENTS_REQUEST,
	GET_VIEWER_ALL_DOCUMENTS_REQUEST_SUCCESS,
	GET_VIEWER_ALL_DOCUMENTS_REQUEST_FAILED,
	GET_VIEWER_ALL_DOCUMENTS_REQUEST_RESET,
	UPDATE_VIEWER_PAGE_NUMBER,
	GET_AUDIT_HISTORY,
	GET_AUDIT_HISTORY_SUCCESS,
	GET_AUDIT_HISTORY_FAILED,
	ADD_ANNOTATION,
	REMOVE_ANNOTATION,
	GET_ANNOTATION_SUCCESS,
	GET_ANNOTATION_FAILED,
	ADD_ANNOTATION_FAILED,
	DELETE_ANNOTATION_SUCCESS,
	DELETE_ANNOTATION_FAILED,
	ADD_ANNOTATION_SUCCESS,
	UPDATE_SKIP_COUNT,
	ZOOM_IN_IMAGE,
	ZOOM_OUT_IMAGE,
	GET_CHAT,
	GET_CHAT_SUCCESS,
	GET_CHAT_FAILED,
	UPDATE_CURRENT_SESSION,
	POST_CHAT,
	POST_CHAT_SUCCESS,
	POST_CHAT_FAILED,
	UPDATE_FILE_TAG_SUCCESS,
	GET_FILE_REQUEST_SUCCESS,
	ROTATE_LEFT_IMAGE,
	ROTATE_RIGHT_IMAGE,
} from "../types"

const initialState = {
	loading: false,
	error: false,
	currentPageNumber: 1,
	allDocuments: {},
	allDocumentsCount: 0,
	allDocumentsLoading: false,
	allDocumentsError: undefined,
	auditHistory: [],
	isAuditHistoryLoading: false,
	annotations: [],
	skipCount: 1,
	isNativeView: false,
	imageZoomScale: 1.0,
	askAnzyz: [],
	chatLoading: false,
	getChatLoading: false,
	currentSessionId: 0,
	imageRotatePosition: 0,
	tags: [],
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_VIEWER_ALL_DOCUMENTS_REQUEST:
			return {
				...state,
				allDocumentsLoading: true,
			}
		case GET_VIEWER_ALL_DOCUMENTS_REQUEST_SUCCESS:
			return {
				...state,
				allDocumentsLoading: false,
				allDocuments: action.payload.data || [],
				allDocumentsCount: action.payload?.count || 0,
			}
		case GET_VIEWER_ALL_DOCUMENTS_REQUEST_FAILED:
			return {
				...state,
				allDocumentsLoading: false,
				allDocumentsError: action.payload,
			}
		case GET_VIEWER_ALL_DOCUMENTS_REQUEST_RESET:
			return {
				...state,
				allDocuments: {},
				allDocumentsError: undefined,
			}
		case UPDATE_VIEWER_PAGE_NUMBER:
			return {
				...state,
				currentPageNumber: action?.payload,
			}
		case GET_AUDIT_HISTORY:
			return {
				...state,
				isAuditHistoryLoading: true,
			}
		case GET_AUDIT_HISTORY_SUCCESS:
			return {
				...state,
				isAuditHistoryLoading: false,
				auditHistory: action.payload.data || [],
			}
		case GET_AUDIT_HISTORY_FAILED:
			return {
				...state,
				isAuditHistoryLoading: false,
				auditHistory: [],
			}
		case ADD_ANNOTATION_SUCCESS:
			return {
				...state,
				annotations: action?.payload?.data,
				isNativeView: action?.payload?.isNative,
			}
		case ADD_ANNOTATION_FAILED:
			return {
				...state,
			}
		case DELETE_ANNOTATION_SUCCESS:
			return {
				...state,
				annotations: action?.payload?.data,
				isNativeView: action?.payload?.isNative,
			}
		case DELETE_ANNOTATION_FAILED:
			return {
				...state,
			}
		case GET_ANNOTATION_SUCCESS:
			return {
				...state,
				annotations: action?.payload?.data,
				isNativeView: action?.payload?.isNative,
			}
		case GET_ANNOTATION_FAILED:
			return {
				...state,
				annotations: [],
			}
		case REMOVE_ANNOTATION:
			return {
				...state,
				annotations: action?.payload?.data || [],
				isNativeView: action?.payload?.isNative,
			}
		case UPDATE_SKIP_COUNT:
			return {
				...state,
				skipCount: action?.payload,
			}
		case ZOOM_IN_IMAGE:
			return {
				...state,
				imageZoomScale: action?.payload,
			}
		case ZOOM_OUT_IMAGE:
			return {
				...state,
				imageZoomScale: action?.payload,
			}
		case GET_CHAT:
			return {
				...state,
				getChatLoading: true,
			}
		case GET_CHAT_SUCCESS:
			return {
				...state,
				askAnzyz: action?.payload,
				getChatLoading: false,
			}
		case GET_CHAT_FAILED:
			return {
				...state,
				askAnzyz: [],
				getChatLoading: false,
			}
		case POST_CHAT:
			return {
				...state,
				chatLoading: true,
			}
		case POST_CHAT_SUCCESS:
			return {
				...state,
				chatLoading: false,
				currentSessionId: action?.payload?.sessions[0]?.session_id,
			}
		case POST_CHAT_FAILED:
			return {
				...state,
				chatLoading: false,
			}
		case UPDATE_CURRENT_SESSION:
			return {
				...state,
				currentSessionId: action?.payload,
			}
		case ROTATE_LEFT_IMAGE:
			return {
				...state,
				imageRotatePosition: action?.payload,
			}
		case ROTATE_RIGHT_IMAGE:
			return {
				...state,
				imageRotatePosition: action?.payload,
			}
		case GET_FILE_REQUEST_SUCCESS:
			return {
				...state,
				tags: action?.payload?.tags || [],
			}
		case UPDATE_FILE_TAG_SUCCESS:
			const tags = [...state?.tags]
			const existingIndex = tags.findIndex((item) => item["tag_id"] === action?.payload?.tag_id)
			if (existingIndex !== -1) {
				tags.splice(existingIndex, 1)
			} else {
				tags.push(action?.payload)
			}
			return {
				...state,
				tags: tags,
			}

		default:
			return state
	}
}
